<template lang='pug'>
div
  letter-head(v-if='order', :no-padding='true')
    .printable-title.top
      .title(v-if='order.invoice_id') Invoice \#{{ order.invoice_id }}
      .order-title Order \#{{ order.id }}
      .po-title(v-if='order.customer_po') PO# {{ order.customer_po }}
  .printable-top-columns(v-if='order')
    el-row(:gutter='$rowGutter')
      el-col(:span='12')
        .top-column
          .top-title DELIVERY ADDRESS
          strong {{ order.customer_account_name }}
          div(v-if='address')
            | {{ address.address_line_1 }}
            div {{ address.address_line_2 }}
            div {{ address.city }}, {{ address.state }}
            div {{ address.zip_code }}
          div(v-if='request!== null && request.suite')
            | Suite: {{request.suite}} 
      el-col(:span='12')
        .top-column
          .top-title DELIVERY
          div
            strong {{ order.request_name }}
          .standout {{ 'Del Date: '}}
            span.standout-accent {{ $formatDate(order.delivery_date) }}
          .standout {{ 'Del Time: ' }}
            span.standout-accent {{ $formatTime(order.delivery_time) }}
          .standout(v-if='request') {{ 'Serves: '}}
            span.standout-accent {{ request.people }} People
    br


    .products-from(v-if='order', style='font-size: 0.8rem')
      | Products from&nbsp;
      strong.cl-primary {{ order.vendor_name }}

  page-content(v-loading='order === null ')
    el-table(
      :data='itemsWithoutTaxTips'
    )
      el-table-column(prop='name', label='Name')
        template(slot-scope='scope')
          .product-name {{ scope.row.name }}
          .description {{ scope.row.product_description }}
          .description(v-if='scope.row.serves') serves {{ scope.row.serves }}
      el-table-column(prop='quantity', label='Quantity', width='100')
        template(slot-scope='scope', v-if='scope.row.type != "TAX" && scope.row.type != "DELIVERY"')
          | {{scope.row.quantity}}
      el-table-column(prop='sale_price_cents', label='Unit price', width='120')
        template(slot-scope='scope', v-if='scope.row.type != "TAX" && scope.row.type != "DELIVERY"')
          | {{$formatCents(scope.row.sale_price_cents) }}
      el-table-column(prop='total_cents', label='Total Price', width='140')
        template(slot-scope='scope', v-if='scope.row.type != "TAX"')
          | {{$formatCents(scope.row.total_cents) }}
    el-row(:gutter='$rowGutter', style='margin-top: 1rem;')
      el-col(:span='12') &nbsp;
      el-col(:span='12', v-if='totalCents && subtotalCents')
        .numeric-summary
          .label Subtotal
          .value {{ $formatCents(subtotalCents) }}
        .numeric-summary
          .label Tax
          .value {{ $formatCents(tax.sale_price_cents) }}
        .numeric-summary(v-if='tip')
          .label Tip
          .value {{ $formatCents(tip.sale_price_cents) }}
        .numeric-summary
          .label
            big Total
          .value
            big {{$formatCents(totalCents)}}
</template>

<script>
  import LetterHead from './LetterHead.vue'
  import PageContent from './PageContent.vue'
  import _ from 'underscore'

  function data(){
    return {
      address: null,
      request: null,
      estimate: null,
      order: null,
    }
  }

  function mounted(){
    this.getData()
  }

  function getData(){
    const fullOrder = `/orders/${this.id}`
    this.$simplecater.get(fullOrder).then((r)=>{
      this.order = r.data.data
      if(this.order.invoice_id){
        this.$simplecater.get(`/invoices/${this.order.invoice_id}`).then((r)=>{
          this.$mergeWithTips(r.data.data.tips, this.order )
        }).catch(()=>{
          this.$message.error("Error loading the address information")
        })
      }
      this.$simplecater.get(`/addresses/${this.order.request_address_id}`).then((r)=>{
        this.address = r.data.data
      }).catch(()=>{
        this.$message.error("Error loading the address information")
      })
      // Request
      this.$simplecater.get(`/requests/${this.order.request_id}`).then((r)=>{
        this.request = r.data.data
      }).catch(()=>{
        this.$message.error("Error loading the request information")
      })
    }).catch(()=>{
      this.$message.error("Error loading the order information")
    })
  }
  const methods = { getData };

  const components = { LetterHead, PageContent }

  const props = {
    id: { required: true }
  }

  const computed = {
    totalCents ( ) {
      return ( this.order && this.order.items )? _.reduce(this.order.items, ( acc, i ) => (acc + i.total_cents), 0 ) : 0
    },

    itemsWithoutTaxTips ( ) {
      return ( this.order && this.order.items )? _.filter(this.order.items, ( x ) => (x.type != "TAX" && x.type != "TIP")) : []
    },

    tax ( ) {
      return ( this.order && this.order.items )? _.find(this.order.items, ( x ) => (x.type === "TAX")) : null
    },

    tip ( ) {
      return ( this.order && this.order.items )? _.find(this.order.items, ( x ) => (x.type === "TIP")) : null
    },

    subtotalCents ( ) {
      return _.reduce(this.order.items, (memo, i) => {
        return ( i.type != "TAX" && i.type != "TIP" )? memo + (i.sale_price_cents * i.quantity) : memo
      }, 0)
    },
  }

  export default { data, components, mounted, methods, props, computed }
</script>

<style scoped lang="sass">

  .standout
    font-weight: bold
    color: #444

  .description
    font-style: italic
    font-size: 12px
    word-break: break-word
    color: #888

  .not-final
    font-size: 20px
    font-weight: bold
    color: #909399

  .printable-title.top
    margin-top: 0px

  .standout-accent
    color: #dd711f

  .serves
    color: #444

  .po-title
    font-size: 16px
    font-weight: bold
    color: #dd711f

  .order-title
    font-size: 16px
    font-weight: bold
    color: #444

</style>



// WEBPACK FOOTER //
// src/print/OrderUserPDF.vue